/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiProjectsQueryResponse,
  GetApiProjectsQueryParams,
} from '../models/GetApiProjects.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiProjectsQueryResponseSchema } from '../zod/getApiProjectsSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiProjectsQueryKey = (params: GetApiProjectsQueryParams) =>
  [{ url: '/api/projects' }, ...(params ? [params] : [])] as const;

export type GetApiProjectsQueryKey = ReturnType<typeof getApiProjectsQueryKey>;

/**
 * {@link /api/projects}
 */
export async function getApiProjects(
  params: GetApiProjectsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiProjectsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: 'GET', url: `/api/projects`, params, ...requestConfig });
  return getApiProjectsQueryResponseSchema.parse(res.data);
}

export function getApiProjectsQueryOptions(
  params: GetApiProjectsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiProjectsQueryKey(params);
  return queryOptions<
    GetApiProjectsQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiProjectsQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiProjects(params, config);
    },
  });
}

/**
 * {@link /api/projects}
 */
export function useGetApiProjects<
  TData = GetApiProjectsQueryResponse,
  TQueryData = GetApiProjectsQueryResponse,
  TQueryKey extends QueryKey = GetApiProjectsQueryKey,
>(
  params: GetApiProjectsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiProjectsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiProjectsQueryKey(params);

  const query = useQuery(
    {
      ...getApiProjectsQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
